import { Route, RouteGroup } from '@billow/easy-route'
import { view } from '@/utilities/view'

export default RouteGroup({

  prefix: '/cinema',

  routes: [
    // screenings
    Route('/screenings', 'cinema.screenings', view('cinema/Screenings')),
    Route('/screening/create', 'cinema.newScreening', view('cinema/NewScreening')),
    Route('/screening/:screening/edit', 'cinema.editScreening', view('cinema/EditScreening')),
    // articles
    Route('/articles', 'cinema.articles', view('cinema/Articles')),
    Route('/article/create', 'cinema.newArticle', view('cinema/NewArticle')),
    Route('/article/:article/edit', 'cinema.editArticle', view('cinema/EditArticle')),
  ]
})